import {slideUp,slideDown} from "../lib/slideUpDown.js";

const accordion = function () {
    const triggers = document.querySelectorAll('[data-accordion_trigger]');
    if (!triggers || triggers.length <=0) {
        return false;
    }

    let isProcessing = false;

    [...triggers].map(trigger => {
        trigger.openTxt = trigger.innerText;
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            
            const parent = this.closest('[data-accordion_item]');
            
            // Sprawdź czy to mobile-only accordion i czy jesteśmy na desktop
            if (parent?.hasAttribute('data-mobile-only') && window.innerWidth > 768) {
                return; // Zablokuj działanie na desktop dla mobile-only accordionów
            }
            
            if (isProcessing) {
                return;
            }
            isProcessing = true;
            setTimeout(() => {
                isProcessing = false;
            }, 500);
            const isActive = parent.classList.contains('active');
            
            // Znajdź content - najpierw spróbuj nextElementSibling z header, jeśli nie - szukaj w parent
            let content = this.closest('*[data-accordion_header]')?.nextElementSibling;
            if (!content || !content.hasAttribute('data-accordion_content')) {
                content = parent.querySelector('[data-accordion_content]');
            }

            // Zamykanie innych aktywnych akordeonów na tym samym poziomie zagnieżdżenia
            [...triggers].forEach(otherTrigger => {
                if (otherTrigger === trigger) return;
                
                const otherParent = otherTrigger.closest('[data-accordion_item]');
                // Sprawdź czy to ten sam poziom zagnieżdżenia (ten sam parentElement)
                if (otherParent && otherParent.parentElement === parent.parentElement && otherParent.classList.contains('active')) {
                    const otherContent = otherParent.querySelector('[data-accordion_content]');
                    slideUp(otherContent);
                    otherTrigger.setAttribute('aria-expanded', 'false');
                    otherParent.classList.remove('active');
                }
            });

            if (isActive) {
                slideUp(content); // Zwijanie treści
                this.setAttribute('aria-expanded', 'false');
                parent.classList.remove('active');
            } else {
                slideDown(content, 'flex'); // Rozwijanie treści
                this.setAttribute('aria-expanded', 'true');
                parent.classList.add('active');
            }
            history.pushState(null, null, '#' + this.id);
        });
    });


    // Scroll to # when link with #
    const hash = window.location.hash;
    if (hash) {
        //console.log(hash);
        const activeAccordionItemTitle = document.querySelector(hash);
        if (activeAccordionItemTitle) {
            activeAccordionItemTitle.click();
        }
    }
    ;

}

export default accordion;